import { useEffect, useMemo, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { api } from '../lib/api';
import SEO from '../components/SEO';
import { detectTimezone, persistTimezone, getPersistedTimezone } from '../lib/timezone';
import DashboardLayout from '../components/dashboard/DashboardLayout.jsx';

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const [hasCreative, setHasCreative] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const boot = async () => {
      setLoading(true);
      setError('');
      let me = null;
      try {
        const res = await api.get('/users/me');
        const d = res?.data || res;
        me = d?.data?.user || d?.user || d?.data || null;
      } catch (err) {
        setError(err?.response?.data?.message || err?.message || 'Failed to load user');
      }
      if (!me) {
        try {
          const raw = localStorage.getItem('auth:user');
          if (raw) me = JSON.parse(raw);
        } catch (e) { void e; }
      }
      let hasCr = false;
      try {
        if (me?.id) {
          const cr = await api.get('/creatives', { params: { user_id: me.id } });
          const list = cr?.data?.data?.creatives || cr?.data?.creatives || [];
          hasCr = Array.isArray(list) && list.some((c) => c?.user_id === me.id);
        }
      } catch (e) { void e; }

      if (me) {
        const rawRoles = Array.isArray(me.roles) ? me.roles.slice() : (me.role ? [me.role] : []);
        const norm = rawRoles.map((r) => String(r || '').trim().toLowerCase());
        if (hasCr && !norm.includes('creative')) {
          const nextRoles = [...rawRoles, 'creative'];
          me = { ...me, roles: nextRoles };
        }
      }

      setUser(me);
      setHasCreative(hasCr);

      

      // Detect and persist timezone
      const existingTz = getPersistedTimezone();
      const tz = existingTz || detectTimezone();
      if (!existingTz) persistTimezone(tz);
      setLoading(false);
    };
    boot();
  }, [location.search]);

  // Normalize roles and compute flags
  const roles = useMemo(() => {
    const raw = Array.isArray(user?.roles) ? user.roles : (user?.role ? [user.role] : []);
    const map = (r) => {
      const k = String(r || '').trim().toLowerCase();
      if (k === 'creative' || k === 'creator' || k === 'artist') return 'creative';
      if (k === 'client' || k === 'buyer' || k === 'customer') return 'client';
      return k;
    };
    return raw.map(map);
  }, [user]);
  const isAdmin = roles.includes('admin');
  const isClient = roles.includes('client') || isAdmin;
  const isCreative = roles.includes('creative') || isAdmin || hasCreative;

  return (
    <>
      <SEO page="dashboard" />
      <DashboardLayout title="Dashboard" breadcrumb={[]} user={user} isClient={isClient} isCreative={isCreative}> 
        {loading && <div>Loading…</div>}
        {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
        {!loading && (
          <div>
            <Outlet context={{ user, setUser, isClient, isCreative }} />
          </div>
        )}
      </DashboardLayout>
    </>
  );
}
